import { OnLoadAction } from '@/types/action'
import { Component } from '@/types/components'

export enum STEP_TYPE {
  USER_FORM = 'USER_FORM', // Save form values into user object
  CHOICES = 'CHOICES', // Save form values into choices array
  DEFAULT = 'DEFAULT', // Data is not saved,

  CONSULTATION = 'CONSULTATION'
}

export enum BACK_TYPE {
  SHORT = 'SHORT', // Button without text
  LONG = 'LONG' // Button with text
}

export type Step = {
  id: string
  name: string
  type: STEP_TYPE
  hideHeader?: boolean // Shown by default
  showFooter?: boolean // Hidden by default

  backButton?: BACK_TYPE // Default is no back button
  stepper?: number // 1, 2, 3 (number of step)
  showLanguageSelector?: boolean // Default is false

  components: { [id: string]: Component }
  componentsOrder: string[] // order of components

  onLoadActions?: OnLoadAction[] // Actions to be executed when the step is loaded
}
